// extracted by mini-css-extract-plugin
export default {"color-grey-1":"#707070","colorGrey1":"#707070","color-black":"#000000","colorBlack":"#000000","item":"_19yj7","svgIcon":"_3ox3c"};